<xng-breadcrumb></xng-breadcrumb>
<div *ngIf="!isLoading" class="container mt-4" style="max-width: 500px;">
  <p class="edit_text" *ngIf="filial.isNew" translate>filials.newFilial</p>
  <p class="edit_text" *ngIf="!filial.isNew" translate>filials.filial.editFilial</p>
  <div class="row">
    <div>
      <form #filialForm="ngForm" class="form-vehicle">
        <!-- Name -->
        <div class="form-group mb-2">
          <label translate>global.name</label>
          <input type="text" #name="ngModel" autocomplete="off" required [ngModel]="filial?.name" class="form-control"
            [class.is-invalid]="name.invalid && name.touched" name="name">
        </div>

        <!-- Address -->
        <div class="form-group mb-2">
          <label translate>global.address</label>
          <input type="text" #address="ngModel" autocomplete="off" [ngModel]="filial?.address" class="form-control"
            name="address">
        </div>

        <!-- Phone -->
        <div class="form-group mb-2">
          <label translate>global.phone</label>
          <input type="text" #phone="ngModel" autocomplete="off" [ngModel]="filial?.phone" class="form-control"
            name="phone">
        </div>

        <app-button *ngIf="filial?.isNew" [text]="'global.save'" [loading]="isLoadingForm"
          (onClick)="addFilial(filialForm)"></app-button>
        <app-button *ngIf="!filial.isNew" [text]="'global.edit'" [loading]="isLoadingForm"
          (onClick)="editFilial(filialForm)"></app-button>

      </form>
    </div>
  </div>
</div>